<template>
  <div class="mobile-search px-4 py-2 shadow mb-3 position-absolute">
    <div class="d-flex justify-content-between search-container">
      <form class="d-flex w-100" autocomplete="off">
        <input
          v-model="search"
          class="w-100"
          type="text"
          placeholder="Búsqueda"
          name="search"
        />
        <button type="button" @click="handlerSearch">
          <i class="fa fa-search"></i>
        </button>
      </form>
      <div class="d-flex justify-content-center align-items-center">
        <i class="fas fa-times font-16" @click="close"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { name as commonModuleName } from '@/modules/common/store'
export default {
  name: 'SearchInputMobile',
  data: () => ({
    search: null,
  }),
  methods: {
    ...mapActions(commonModuleName, ['setFilterText']),
    handlerSearch() {
      this.setFilterText(this.search)
    },
    close() {
      this.search = null
      this.setFilterText('')
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/v2/brand_variables.scss';

.mobile-search {
  margin-top: 56px;
  height: 61px;
  width: 100%;
  background: #f4f6f3 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  opacity: 1;
  z-index: 999;
  left: 0;

  & .fas.fa-times {
    color: $secondary-5;
  }

  & input[type='text'] {
    padding: 6px;
    font-size: 17px;
    border: 1px solid #e2e2e2;
    border-right: none;
    border-radius: 4px 0px 0px 4px;
    width: 80%;
  }
  & input[type='text']::placeholder {
    color: black;
    font-weight: bold;
    font-size: 14px;
  }
  & input[type='text']:focus {
    outline: none;
  }

  & .search-container button {
    padding: 6px 10px;
    margin-right: 16px;
    background: #ddd;
    font-size: 17px;
    border: none;
    border-radius: 0px 4px 4px 0px;
    cursor: pointer;
    background: #2db782;
    color: #fff;
  }
}
</style>
